module.exports = __webpack_public_path__ + "static/media/afori_avsandare_neg.db0acac6.svg";